import styled from '@mui/material/styles/styled';

export const Wrapper = styled('div', { shouldForwardProp: (prop) => prop !== 'active' }
  )(({ theme, active }) => ({
  width: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '4px',
  backgroundColor: active ? theme.palette.background.default : 'transparent',
  border: `1px solid ${theme.palette.text.hint}`,
  borderRadius: '4px',
  color: theme.palette.primary.main,
  '&:hover': {
    borderColor: theme.palette.primary.main,
  }
}));

export const Label = styled('div')(() => ({
  color: 'inherit',
  fontSize: '.75rem',
  fontWeight: 700
}));